var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item,index){return _c(item.name,_vm._b({key:_vm.key(item, index),tag:"component",on:{"close":() => _vm.close(index)}},'component',item.props,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }